// extracted by mini-css-extract-plugin
export default {"text":"Requisites_text__N1biU","number":"Requisites_number__wN0PF"};